import { call, put, takeEvery, all } from "redux-saga/effects";
import { createNewSingleTemplate } from "../../networking/new-template/networking";
import * as types from "../types/new-template";

function* performAddNewTemplate(action) {
  try {
    if (action.details) {
      const response = yield call(createNewSingleTemplate, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_NEW_TEMPLATE });
      } else {
        throw new Error("Kunne ikke legge til ny kunde.");
      }
    } else {
      throw new Error("Kunne ikke opprette ny liste.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_NEW_TEMPLATE, message: e });
  }
}

function* newTemplateSaga() {
  yield all([takeEvery(types.REQUEST_ADD_NEW_TEMPLATE, performAddNewTemplate)]);
}

export default newTemplateSaga;
